<template>
  <div>
    <div
      class="modal fade"
      id="modal-import-supplier"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t() }}
            </h4>
          </div> -->
          <div class="modal-body">
            <div class="">
              <!--  -->
              <div class="app-container">
                <div style="margin-bottom: 15px">
                  <p>{{ $t("common.download_template_excel") }}</p>
                  <i class="fa fa-download" aria-hidden="true"></i>
                  <a @click="exportExcelFile">{{
                    $t("common.exportFileExcel")
                  }}</a>
                </div>
                <upload-excel-component
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                />
                <b-table
                  striped
                  hover
                  small
                  :items="resultImportList"
                  :fields="resultImportList_fields"
                  class="mt-3"
                  outlined
                  :busy="isLoading"
                >
                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{
                        $t("reportLiabilitiesReport.loading")
                      }}</strong>
                    </div>
                  </template>
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                  <template slot="statusImport" slot-scope="row">
                    <!-- {{row}} -->
                    <p
                      style="color:green"
                      v-if="row.item.statusImport == 'Success'"
                    >
                      {{ row.item.statusImport }}
                    </p>
                    <p style="color:red" v-else>{{ row.item.statusImport }}</p>
                    <p />
                  </template>
                </b-table>
              </div>
              <!--  -->
            </div>
          </div>
          <div class="modal-footer" style="text-align: center">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import XLSX from "xlsx";
import { mapActions, mapGetters } from "vuex";
// import utils from '@/lib/utils'

export default {
  components: {
    UploadExcelComponent
  },
  data: () => ({
    tableData: [],
    tableHeader: [],
    hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a

    resultImportList: [], // Result import
    resultImportList_fields: [
      {
        key: "supplier_code",
        label: "supplierManagement.supplierCode",
        sortable: true,
        class: "text-center"
      },
      {
        key: "supplier_name",
        label: "escalationprocess.name",
        sortable: true,
        class: "text-center"
      },
      {
        key: "statusImport",
        label: "common.status",
        sortable: true,
        class: "text-center"
      },
      {
        key: "errorDetail",
        label: "common.error",
        sortable: true,
        class: "text-center"
      }
    ],
    isLoading: false,
    validateElement: {},
    exportExcelData: {
      headerList: [
        "supplierManagement.supplierCode",
        "supplierManagement.supplierName",
        "supplierManagement.supplierAddress",
        "supplierManagement.supplierEmail",
        "supplierManagement.supplierPhone"
      ],
      dataList: []
    }
  }),
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });
      return false;
    },

    handleSuccess({ results, header }) {
      this.tableData = results;
      let data = {
        headers: header,
        dataImport: results
      };
      // init empty
      this.resultImportList = [];
      this.isLoading = true;
      this.IMPORT_ASSET_SUPPLIER(data).then(
        function(res) {
          res.dataResult.forEach(v => {
            let dataPass = {
              supplier_code: v.supplier_code,
              supplier_name: v.supplier_name,
              statusImport: v.status,
              errorDetail: v.error_message
            };
            this.resultImportList.push(dataPass);
          });
          this.$emit('callbackSupplierList', true)
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function(error) {
          let dataError = {
            supplier_code: "Unknown",
            supplier_name: "Unknown",
            statusImport: "FAIL",
            errorDetail: "Unknown"
          };
          this.resultImportList.push(dataError);
          this.isLoading = false;
        }.bind(this)
      );
      this.tableHeader = header;
    },
    onCloseModal: function() {
      $("#modal-import-supplier").modal("hide");
    },
    onShowModal: function() {
      $("#modal-import-supplier").modal("show");
    },
    onShowImport: function() {
      this.onShowModal();
    },
    exportExcelFile: function() {
      let header = this.exportExcelData.headerList;
      let supplierCodeHeader = header[0];
      let supplierNameHeader = header[1];
      let supplierPhoneHeader = header[2];
      let supplierEmailHeader = header[3];
      let supplierAddressHeader = header[4];
      let data_list = [];
      let json_data = [
        {
          [this.$t(supplierCodeHeader)]: "supplier_code",
          [this.$t(supplierNameHeader)]: "supplier_name",
          [this.$t(supplierPhoneHeader)]: "",
          [this.$t(supplierEmailHeader)]: "",
          [this.$t(supplierAddressHeader)]: ""
        }
      ];

      data_list = json_data;
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "supplier"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "Supplier.xlsx"); // name of the file is 'book.xlsx'
    },
    ...mapActions([
      "IMPORT_ASSET_SUPPLIER"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Property/ImportSupplierModal.vue